import Figure from './Figure';
export default Figure;